import React from "react";
import { ThemePalette } from "../../../../../../theme/_Types";
import { Button } from "../../../../05-atoms/Button";
import * as I18n from "../../../../../../utils/translations/I18n";
export var LogoutButton = function (props) {
    var theme = props.allDevices
        ? { palette: ThemePalette.CONTRAST_TERTIARY }
        : { palette: ThemePalette.BRAND_ACCENT };
    var label = props.allDevices
        ? I18n.getText("mary.09-views.03-modals.accountsettings.tabs.logoutbutton-all-devices-label", "Logout from all devices")
        : I18n.getText("mary.09-views.03-modals.accountsettings.tabs.logoutbutton-label", "Logout");
    return (React.createElement(Button, { theme: theme, link: { onClick: function () { return props.signOut(props.allDevices); } } }, label));
};
